import React from "react"
import HeroSection from "./hero-section"
import FilterSection from './filter-section'
import ImageBox from "./image-box"
import FindrehabCenters from "../find-rehab-centers"
import MedicalSpecialist from "./medical-specialist"
import Therapist from "./therapist"
import InterventionService from "./intervention-service"
import WhyFindRehab from "./why-rehab-find"
import SearchSection from "./search-section"
import Quizzes from "./quizzes"

const HelpCenter = () => {
  return (
    <>
      <HeroSection />
      <FilterSection/>
      <ImageBox />
      <FindrehabCenters page="Help Center"/>
      <MedicalSpecialist />
      <Therapist />
      <InterventionService />
      <WhyFindRehab />
      <SearchSection />
      <Quizzes/>
    </>
  )
}

export default HelpCenter
